import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';


/**
 * Loads the HDRI from /hdri/cayley_interior_4k.hdr and applies it as the
 * scene environment map (for IBL reflections / global illumination).
 * scene.background is left untouched so the CSS/scene background colour shows.
 * Resolves once the texture is applied; the caller can fire-and-forget.
 */
export function setupEnvironment(
  scene: THREE.Scene,
  renderer: THREE.WebGLRenderer
): Promise<void> {
  return new Promise((resolve) => {
    const pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();

    new RGBELoader().load(
      '/hdri/cayley_interior_4k.hdr',
      (hdrTexture) => {
        const envMap = pmrem.fromEquirectangular(hdrTexture).texture;
        scene.environment = envMap;
        scene.environmentIntensity = 1.0;
        hdrTexture.dispose();
        pmrem.dispose();
        resolve();
      }
    );
  });
}

/**
 * Adds a shadow-receiving ground plane.
 * Sits just below y = 0 so models placed at ground level look grounded.
 */
export function createGroundPlane(scene: THREE.Scene): void {
  const geo = new THREE.PlaneGeometry(30, 30);
  const mat = new THREE.MeshStandardMaterial({
    color: 0x111122,
    roughness: 0.95,
    metalness: 0.0,
  });
  const plane = new THREE.Mesh(geo, mat);
  plane.rotation.x = -Math.PI / 2;
  plane.position.y = -1.5;
  plane.receiveShadow = true;
  scene.add(plane);
}
